import { MY_CONNECT_LINE } from 'dialer/components/widgets/public/helpers/DialerSettings'
import { DEFAULT_START_PAGE } from 'dialer/helpers/constants'

import { ICallStatus } from './ICallStatus'
import { IPagination } from './models'
import { MY_CONNECT_TYPE } from './MyConnectType'

export interface IFormData {
  [MY_CONNECT_TYPE.Customer]?: IObjectAny
  [MY_CONNECT_TYPE.Distributor]?: IObjectAny
  [MY_CONNECT_TYPE.DistributorContact]?: IObjectAny
  [MY_CONNECT_TYPE.Partner]?: IObjectAny
  [MY_CONNECT_TYPE.PartnerContact]?: IObjectAny
  [MY_CONNECT_TYPE.HP]?: IObjectAny
  [MY_CONNECT_TYPE.Other]?: IObjectAny
}

export enum DISPLAY_MODE {
  Search = 'search',
  Call = 'call',
  CallAnyway = 'callAnyway',
  NoLine = 'noLine',
}

export interface IDialerFilter {
  input: string
  countryCodeList: string[]
  showMyPartners: boolean
  onlyFavourite: boolean
}

export type TStoredDialerFilters = Omit<IDialerFilter, 'input'>

export interface IDialerState {
  appId: string
  activeTab: MY_CONNECT_TYPE
  filters: IDialerFilter
  formData?: IFormData
  callStatus?: ICallStatus
  mode: DISPLAY_MODE
  wip: boolean
  searchResult: ISearchResult
  pagination: IPagination
}

export interface ISearchResult {
  searchHash: string
  items: Record<string, any>[]
  total: number
}

export const getEmptySearchResult = (): ISearchResult => ({ items: [], total: 0, searchHash: '' })
export const getSearchResultWithEmptySearchHash = (value: ISearchResult): ISearchResult => ({
  ...value,
  searchHash: '',
})

export const getPaginationWithStartPage = (pagination: IPagination) => ({
  ...pagination,
  page: pagination.startPage ?? DEFAULT_START_PAGE,
})

export const getEmptyCallStatus = (connectLine?: MY_CONNECT_LINE): ICallStatus => ({
  lastCallRequest: {
    isCallAnyway: false,
    line: connectLine ?? MY_CONNECT_LINE.france, // todo: add 'unknown' in MY_CONNECT_LINE?
    call: {
      inputValue: '',
      customerEndpoint: '',
    },
  },
  initialCustomerEndpoint: '',
})
